import { ProductDTO, ProductType, ProductUnit } from './agreement';

export enum BookingSource {
  Portal = 'portal',
  Mobile = 'mobile',
  Admin = 'admin',
}

export interface ProductBooking {
  id: string;
  productId: string;
  agreementId: string;
  date: string;
  quantity: number;
  projectId: string | null;
  organizationalUnitId: string;
  source: BookingSource;
  createdById: string | null;
  product: Pick<ProductDTO, 'id' | 'name' | 'shortName'> & {
    unit: ProductUnit | null;
    pricePerUnit: number | null;
    operativeSelectable: boolean;
    type: ProductType;
  };
}

export interface GetProductBookingsParams {
  agreementIds?: string[];
  from: string;
  to: string;
  productId?: string;
  /**
   * Narrows the result to the bookings recorded on this shift.
   *
   * Omitting it keeps the day-level read, which is what the portal wants: it shows a whole
   * agreement's day regardless of which shift reported each entry. Only the mobile sheet, which
   * is always looking at one shift, passes it.
   *
   * There is deliberately no way to ask for the bookings that carry no shift. The backend takes
   * a single uuid, so a shiftless spelling would have to be smuggled past validation as a
   * sentinel. That means a shift-scoped read does not see portal-created entries for the same
   * day, nor anything recorded before WILP-13236 gave the column a value.
   */
  shiftId?: string;
}

export interface CreateProductBookingPayload {
  productId: string;
  agreementId: string;
  date: string;
  quantity: number;
  projectId?: string;
  shiftId?: string;
  source: BookingSource;
}

export interface UpdateProductBookingPayload {
  quantity: number;
}
